import { connect } from 'react-redux';
import React from 'react';
import { Typography } from '@mui/material';
import { secondsToDigitalText } from '../../../../../utilities/timeUtilities';

const AudioPlaybackCounter = ({ duration, canPlay, appliedPlaybackTime }) => {
    return (
        <Typography sx={{ whiteSpace: 'nowrap' }}> {secondsToDigitalText(appliedPlaybackTime)} / {!canPlay ? '0:00' : secondsToDigitalText(duration)} </Typography>
    );
}

const mapStateToProps = (state) => {
    const {
        appliedPlaybackTime,
        audioDuration: duration
    } = state.create;

    return {
        duration,
        appliedPlaybackTime
    }
};

export default connect(mapStateToProps, {})(AudioPlaybackCounter);